import { render, staticRenderFns } from "./ConfirmAddOtherPlatformDocumentTableModal.vue?vue&type=template&id=1b309e28&scoped=true&"
import script from "./ConfirmAddOtherPlatformDocumentTableModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddOtherPlatformDocumentTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b309e28",
  null
  
)

export default component.exports